/* Posterized - the customer's own picture in the cart (Arjun 18-09).
   The Corner cart drawer and cart page show every line with the product's stock photo. For the
   builders (Build Your Wall, Mix & Match) the wall the customer made is on the line as the hidden
   property _Wall Preview, and for the own-photo products the uploads are _Poster 1..N - the floor
   sees them, the customer never did ("did my photo go through?"). This swaps the line's thumbnail
   for that picture, marks it "Your wall / Your photo", and opens it full-size on a tap.
   Corner renders its lines from /cart.js (oldest first; /cart.js lists newest first), so a line is
   matched to its cart item by variant id and, when the same variant is in the cart twice, by the
   property text Corner prints. Breeze's own checkout page is out of reach (their iframe).
   Arjun 18-09 evening: "cart la upload panna images preview link ethuvum illa". Most customer photos now come
   through the builders (Build Your Wall / Mix & Match slots, _Slot N Image on the uploads worker - 1 to 20 per
   wall), and the line only showed the wall. Every line with a picture now also gets a visible
   "See your wall + 3 photos" / "See your photos" button under its title; the viewer shows the wall first, then
   every photo the customer uploaded, in a grid. */
(function () {
  if (window.__pzCartThumbs) return;
  window.__pzCartThumbs = true;
  var css = document.createElement('style');
  css.textContent =
    '.pz-ct-box{cursor:zoom-in}' +
    '.pz-ct-box img[data-pz-thumb]{width:100%;height:76px;object-fit:cover;object-position:50% 40%;border-radius:6px;background:#eee;display:block}' +
    /* a pill on the picture's bottom edge (the image box is stretched to the whole line by Corner, so never bottom:0) */
    '.pz-ct-badge{position:absolute;left:50%;top:66px;transform:translateX(-50%);z-index:12;width:max-content;max-width:74px;padding:3px 6px;' +
      'background:#ffba00;color:#111;font:800 8px/1 "Barlow",system-ui,sans-serif;letter-spacing:.03em;text-align:center;white-space:nowrap;' +
      'border-radius:999px;box-shadow:0 1px 3px rgba(0,0,0,.28);pointer-events:none}' +
    /* the viewer (Arjun 18-09 night): a scrolling sheet - a sticky top bar with a close button, then labelled
       sections; every picture carries its slot number. 19-09: "Images you picked" (our designs) and "Images you
       uploaded" (their photos) apart, three across and a smaller wall - less scrolling. */
    '.pz-ct-lb{position:fixed;inset:0;z-index:2147483000;background:#111;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:0 14px 32px;-webkit-tap-highlight-color:transparent;font-family:"Barlow",system-ui,sans-serif}' +
    '.pz-ct-lb-top{position:sticky;top:0;z-index:3;display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 -14px 4px;padding:12px 14px;background:#111;border-bottom:1px solid rgba(255,255,255,.1);color:#fff;font:800 16px/1.2 "Barlow",system-ui,sans-serif}' +
    '.pz-ct-lb-x{flex:none;display:inline-flex;align-items:center;gap:6px;height:36px;padding:0 14px 0 12px;border:0;border-radius:999px;background:#fff;color:#111;font:800 13px/1 "Barlow",system-ui,sans-serif;cursor:pointer}' +
    '.pz-ct-lb-x b{font-size:17px;line-height:1;font-weight:800}' +
    '.pz-ct-lb-sec{max-width:560px;margin:0 auto}' +
    '.pz-ct-lb-h{display:flex;align-items:center;gap:8px;margin:14px 0 8px;color:#fff;font:800 13px/1.2 "Barlow",system-ui,sans-serif;letter-spacing:.1em;text-transform:uppercase}' +
    '.pz-ct-lb-h i{font-style:normal;background:#ffba00;color:#111;border-radius:999px;padding:3px 8px;font-size:11px;letter-spacing:.04em}' +
    '.pz-ct-lb-h small{margin-left:auto;color:#9a9a9a;font-weight:600;font-size:11.5px;letter-spacing:0;text-transform:none}' +
    '.pz-ct-lb-wall{display:block;width:auto;max-width:100%;height:auto;max-height:36vh;margin:0 auto;border-radius:10px;background:#fff;box-shadow:0 8px 30px rgba(0,0,0,.5)}' +
    '.pz-ct-lb-line{height:1px;background:rgba(255,255,255,.12);margin:16px 0 0}' +
    '.pz-ct-lb-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}' +
    '.pz-ct-lb-grid.one{grid-template-columns:minmax(0,46%)}' +
    '.pz-ct-lb-grid figure{margin:0;position:relative}' +
    '.pz-ct-lb-grid img{display:block;width:100%;height:auto;border-radius:6px;background:#222}' +
    '.pz-ct-lb-grid figcaption{position:absolute;left:4px;top:4px;padding:3px 6px;border-radius:999px;background:#ffba00;color:#111;font:800 9.5px/1 "Barlow",system-ui,sans-serif;box-shadow:0 1px 4px rgba(0,0,0,.4)}' +
    '.pz-ct-lb-grid.own figcaption{background:#fff}' +
    '.pz-ct-lb-foot{max-width:560px;margin:18px auto 0;color:#9a9a9a;font:600 12px/1.45 "Barlow",system-ui,sans-serif;text-align:center}' +
    '.pz-ct-see{display:inline-flex;align-items:center;gap:5px;margin:6px 0 0;padding:5px 10px 5px 8px;border:1.5px solid #111;border-radius:999px;' +
      'background:#ffba00;color:#111;font:800 11px/1.1 "Barlow",system-ui,sans-serif;letter-spacing:.01em;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.pz-ct-see svg{width:13px;height:13px;flex:none}' +
    /* Arjun 27-09: "cart la custom product add panna slot details theva illa, just See your wall apro Edit your wall
       mattum". A built wall's "Slot N · size: design" rows (up to 23 of them) are hidden in the drawer and on the
       cart page - the line keeps them (the order and the floor still get every slot). The CSS rule by product link
       hides them before the first paint; data-pz-built (set below from the cart item) covers any other builder line. */
    /* two separate rules: a browser without :has() drops a whole selector list, fallback included (review 27-09) */
    '[data-testid="corner-cart-line"][data-pz-built] .corner-cowi-cart-item-line-properties{display:none!important}' +
    '[data-testid="corner-cart-line"]:has(a[href*="/products/build-your-"]) .corner-cowi-cart-item-line-properties{display:none!important}' +
    '.pz-ct-acts{display:flex!important;flex-wrap:wrap;gap:6px;align-items:center}' +
    '';
  document.head.appendChild(css);

  var cart = { items: null, at: 0, busy: false, waiters: [] };
  function loadCart(cb) {
    if (cart.items && Date.now() - cart.at < 1200) { cb(cart.items); return; }
    cart.waiters.push(cb);
    if (cart.busy) return;
    cart.busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      cart.items = c.items || []; cart.at = Date.now();
    }).catch(function () { cart.items = cart.items || []; }).then(function () {
      cart.busy = false;
      var w = cart.waiters; cart.waiters = [];
      w.forEach(function (fn) { fn(cart.items); });
    });
  }

  function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }
  /* the customer's pictures on a cart item, if any. The builders (Build Your Wall, Mix & Match) write for every
     spot a visible "Slot N · <size>" - the design's title for a pick from our catalogue, "Your photo ✓" for an
     upload - plus the picture in _Slot N Image, and the finished wall in _Wall Preview; own-photo products write
     _Poster N. 19-09 (Arjun: "images you picked, images you uploaded nu thaniya"): the label decides - catalogue
     designs from the floor's design drops live on img.posterizedfloor.uk, not only on cdn.shopify.com, so the
     host said "upload" for picks (Ocean Eyes, Thriller... showed as "uploaded"). */
  function picOf(item) {
    var p = item.properties || {}, keys = Object.keys(p);
    var byN = function (a, b) { return a.n - b.n; };
    var picked = [], ups = [];
    keys.forEach(function (k) {
      var m = /^_Slot (\d+) Image$/.exec(k);
      if (!m || !p[k]) return;
      var n = parseInt(m[1], 10), u = String(p[k]);
      if (u.indexOf('//') === 0) u = 'https:' + u;
      var vk = keys.filter(function (x) { return x.indexOf('Slot ' + n + ' \u00b7 ') === 0; })[0];
      var own = vk ? /^Your photo/i.test(String(p[vk])) : /posterized-uploads\./.test(u);
      (own ? ups : picked).push({ u: u, n: n, tag: 'Slot ' + n, t: own ? '' : String(p[vk] || '') });
    });
    picked.sort(byN); ups.sort(byN);
    var posters = keys.filter(function (k) { return /^_Poster \d+$/.test(k) && p[k]; })
      .map(function (k) { var n = parseInt(k.slice(8), 10); return { u: String(p[k]), n: n, tag: 'Photo ' + n, t: '' }; }).sort(byN);
    var own = posters.concat(ups);
    var wall = p['_Wall Preview'] ? String(p['_Wall Preview']) : null;
    var built = !!wall || picked.length + ups.length > 0;   /* a builder line (its preview can be missing) */
    if (!built && !own.length) return null;
    /* a wall from the builder (it writes _Wall Layout) can be reopened there: Edit wall -> ?pzedit=<line key> */
    var edit = built && p['_Wall Layout'] && item.url && item.key
      ? item.url + (item.url.indexOf('?') > -1 ? '&' : '?') + 'pzedit=' + encodeURIComponent(item.key) : null;
    return { src: wall || (own[0] || picked[0]).u, wall: wall, picked: picked, ups: own, built: built, edit: edit,
             label: built ? 'Your wall ✓' : (own.length > 1 ? 'Your photos · ' + own.length : 'Your photo ✓'),
             see: built ? (ups.length ? 'See your wall + ' + plural(ups.length, 'photo') : 'See your wall')
                        : (own.length > 1 ? 'See your ' + own.length + ' photos' : 'See your photo'),
             cap: built ? 'Your wall' : (own.length > 1 ? 'Your ' + own.length + ' photos' : 'Your photo') };
  }
  /* how many of the item's visible property values Corner printed inside this line */
  function score(line, item) {
    var txt = (line.textContent || '').replace(/\s+/g, ' ');   /* textContent: the property rows are hidden (27-09) */
    var p = item.properties || {}, n = 0;
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || !p[k]) return;
      if (txt.indexOf(String(p[k]).replace(/\s+/g, ' ').slice(0, 40)) > -1) n++;
    });
    return n;
  }

  var lb = null;
  function openLightbox(pic) {
    closeLightbox();
    lb = document.createElement('div');
    lb.className = 'pz-ct-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    var q = function (u) { return String(u).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
    /* our designs come in small (the CDN resizes them, as the builder's own tiles do); uploads as they are */
    var small = function (u) { return /cdn\.shopify\.com|posterizedfloor\.uk/.test(u) ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=360' : u; };
    var tagged = !!pic.wall || pic.picked.length + pic.ups.length > 1;
    var grid = function (list, own) {
      return '<div class="pz-ct-lb-grid' + (own ? ' own' : '') + (list.length === 1 ? ' one' : '') + '">' +
        list.map(function (x, i) {
          return '<figure><img src="' + q(own ? x.u : small(x.u)) + '" alt="' + q(x.t || x.tag) + '"' + (i > 8 ? ' loading="lazy"' : '') + ' decoding="async">' +
            (tagged ? '<figcaption>' + x.tag + '</figcaption>' : '') + '</figure>';
        }).join('') + '</div>';
    };
    var parts = [];
    if (pic.wall) parts.push('<div class="pz-ct-lb-h">Your wall<small>how it will look</small></div><img class="pz-ct-lb-wall" src="' + q(pic.wall) + '" alt="Your wall">');
    if (pic.picked.length) parts.push('<div class="pz-ct-lb-h">Images you picked<i>' + pic.picked.length + '</i><small>from our designs</small></div>' + grid(pic.picked, false));
    if (pic.ups.length) parts.push('<div class="pz-ct-lb-h">Images you uploaded<i>' + pic.ups.length + '</i><small>your own photos</small></div>' + grid(pic.ups, true));
    var h = '<div class="pz-ct-lb-top"><span>' + pic.cap + '</span>' +
      '<button type="button" class="pz-ct-lb-x" aria-label="Close"><b aria-hidden="true">&#10005;</b>Close</button></div>' +
      parts.map(function (x) { return '<div class="pz-ct-lb-sec">' + x + '</div>'; }).join('<div class="pz-ct-lb-sec"><div class="pz-ct-lb-line"></div></div>');
    h += '<p class="pz-ct-lb-foot">This is exactly what we print. Want to change a design or a photo? ' +
      (pic.edit ? 'Tap Edit wall in your cart.' : 'Remove the item and add it again before checkout.') + '</p>';
    lb.innerHTML = h;
    /* close: the button, a tap on the dark background, or Escape - a tap on a picture keeps the viewer open */
    lb.addEventListener('click', function (e) {
      var t = e.target;
      if (t === lb || (t.closest && (t.closest('.pz-ct-lb-x') || t.classList.contains('pz-ct-lb-sec') || t.classList.contains('pz-ct-lb-foot')))) closeLightbox();
    });
    document.body.appendChild(lb);
    document.addEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') closeLightbox(); }
  function closeLightbox() {
    if (lb && lb.parentNode) lb.parentNode.removeChild(lb);
    lb = null;
    document.removeEventListener('keydown', onKey);
  }

  /* Corner keeps the closed drawer's lines in the DOM (opacity 0 on #corner-cowi-open-primary-card) */
  function shown(el) {
    if (el.checkVisibility) return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    var card = document.getElementById('corner-cowi-open-primary-card');
    return !card || !card.contains(el) || parseFloat(window.getComputedStyle(card).opacity) > 0;
  }
  function unmark(line) {
    if (!line.__pzPic) return;
    line.__pzPic = null;
    var img = line.querySelector('img[data-pz-thumb]');
    if (img) img.removeAttribute('data-pz-thumb');
    var badge = line.querySelector('.pz-ct-badge');
    if (badge && badge.parentNode) { badge.parentNode.classList.remove('pz-ct-box'); badge.parentNode.removeChild(badge); }
    var see = line.querySelector('.pz-ct-see');
    if (see && see.parentNode) see.parentNode.removeChild(see);
    var ed = line.querySelector('.pz-ct-edit');
    if (ed && ed.parentNode) ed.parentNode.removeChild(ed);
    var acts = line.querySelector('.pz-ct-acts');
    if (acts && acts.parentNode && !acts.children.length) acts.parentNode.removeChild(acts);
    line.removeAttribute('data-pz-built');
  }
  /* sizes inline + !important: Corner's own stylesheet stretches svgs and buttons inside its lines */
  var EYE = '<svg width="13" height="13" style="width:13px!important;height:13px!important;min-width:13px;max-width:13px;flex:none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  var PEN = '<svg width="13" height="13" style="width:13px!important;height:13px!important;min-width:13px;max-width:13px;flex:none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  /* the visible "See your photos" button under the line's title (Corner may re-render the line: re-added each pass) */
  function ensureSee(line, pic) {
    var host = line.querySelector('.corner-cowi-cart-item-list-item-info-title-wrapper .grow') ||
      line.querySelector('[data-testid="corner-cowi-cart-item-list-item-info-body"]');
    if (!host) return;
    /* 27-09: See your wall + Edit wall side by side in one row */
    var row = line.querySelector('.pz-ct-acts');
    if (!row) {
      row = document.createElement('div');
      row.className = 'pz-ct-acts';
      row.setAttribute('style', 'display:flex!important;flex-wrap:wrap!important;gap:6px!important;align-items:center!important;margin:0!important;padding:0!important');
      host.appendChild(row);
    }
    var b = line.querySelector('.pz-ct-see');
    if (b && b.parentNode !== row) row.insertBefore(b, row.firstChild);
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-ct-see';
      b.setAttribute('style', 'display:inline-flex!important;align-items:center!important;gap:5px!important;width:auto!important;max-width:100%!important;' +
        'height:auto!important;min-height:0!important;flex:none!important;align-self:flex-start!important;margin:7px 0 0!important;' +
        'padding:6px 11px 6px 9px!important;border:1.5px solid #111!important;border-radius:999px!important;background:#ffba00!important;' +
        'color:#111!important;font:800 11.5px/1.1 "Barlow",system-ui,sans-serif!important;letter-spacing:.01em!important;cursor:pointer');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (line.__pzPic) openLightbox(line.__pzPic);
      }, true);
      row.insertBefore(b, row.firstChild);
    }
    /* compare the label, never innerHTML: the browser re-serialises the svg, so an innerHTML compare never
       matched and every pass rewrote the button - a mutation loop with the observer below */
    if (b.getAttribute('data-see') !== pic.see) {
      b.setAttribute('data-see', pic.see);
      b.innerHTML = EYE + '<span>' + pic.see + '</span>';
    }
    if (pic.built) { if (!line.hasAttribute('data-pz-built')) line.setAttribute('data-pz-built', '1'); }
    else if (line.hasAttribute('data-pz-built')) line.removeAttribute('data-pz-built');
    /* Edit wall (Arjun 27-09): back to the builder on this wall's own pack, every pick in place; OK there
       rewrites this same cart line */
    var e = line.querySelector('.pz-ct-edit');
    if (!pic.edit) { if (e && e.parentNode) e.parentNode.removeChild(e); return; }
    if (!e) {
      e = document.createElement('button');
      e.type = 'button';
      e.className = 'pz-ct-edit';
      e.setAttribute('style', 'display:inline-flex!important;align-items:center!important;gap:5px!important;width:auto!important;max-width:100%!important;' +
        'height:auto!important;min-height:0!important;flex:none!important;align-self:flex-start!important;margin:7px 0 0!important;' +
        'padding:6px 11px 6px 9px!important;border:1.5px solid #111!important;border-radius:999px!important;background:#fff!important;' +
        'color:#111!important;font:800 11.5px/1.1 "Barlow",system-ui,sans-serif!important;letter-spacing:.01em!important;cursor:pointer');
      e.innerHTML = PEN + '<span>Edit wall</span>';
      e.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var u = line.__pzPic && line.__pzPic.edit;
        if (!u) return;
        this.style.opacity = '.55';
        location.href = u;
      }, true);
    }
    if (e.parentNode !== row) row.appendChild(e);
    if (e.getAttribute('data-edit') !== pic.edit) e.setAttribute('data-edit', pic.edit);
  }
  function apply() {
    watchDrawer();
    /* only the lines on screen, grouped per list: the /cart page has its own list AND the closed drawer's list
       stays in the DOM, in either order (18-09 night: checking only the first line in the DOM skipped the whole
       cart page whenever the hidden drawer's list came first). Closed drawer only: no /cart.js, no downloads. */
    var all = document.querySelectorAll('[data-testid="corner-cart-line"]');
    var lists = [], groups = [];
    for (var a = 0; a < all.length; a++) {
      if (!shown(all[a])) continue;
      var box0 = all[a].parentElement;
      var list = (box0 && box0.closest('#corner-cowi-cart-item-list')) || box0;
      var gi = lists.indexOf(list);
      if (gi < 0) { lists.push(list); groups.push([]); gi = groups.length - 1; }
      groups[gi].push(all[a]);
    }
    if (!groups.length) return;
    loadCart(function (items) {
      var byVar = {};
      items.forEach(function (it) { if (picOf(it)) (byVar[String(it.variant_id)] = byVar[String(it.variant_id)] || []).push(it); });
      groups.forEach(function (lines) { match(lines, byVar); });
    });
  }
  function match(lines, byVar) {
      var used = {};
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var cands = (byVar[line.getAttribute('data-corner-variant-id') || ''] || []).filter(function (it) { return !used[it.key]; });
        if (!cands.length) { unmark(line); continue; }   /* Corner reuses a line's node for another item */
        var it = cands[0];
        if (cands.length > 1) {
          var best = -1;
          /* >= : on a tie the oldest candidate wins (Corner rows are oldest first, /cart.js newest first) - two walls with
             identical text no longer swap thumbnails / Edit links (review 27-09) */
          cands.forEach(function (c) { var s = score(line, c); if (s >= best) { best = s; it = c; } });
        }
        used[it.key] = 1;
        var pic = picOf(it);
        if (!pic) continue;
        line.__pzPic = pic;
        ensureSee(line, pic);
        var img = line.querySelector('img[data-testid="item-image"]');
        if (!img) continue;
        if (img.getAttribute('data-pz-thumb') === pic.src && img.getAttribute('src') === pic.src && line.querySelector('.pz-ct-badge')) continue;
        if (img.__pzBad === pic.src) continue;   /* that picture failed to load once: keep the stock photo */
        if (!img.__pzOrig) img.__pzOrig = img.getAttribute('src');
        img.setAttribute('data-pz-thumb', pic.src);
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        /* eager: a lazy image inside the sliding drawer sometimes never loaded on iPhone */
        img.loading = 'eager'; img.decoding = 'async';
        img.onerror = function () { if (this.__pzOrig && this.getAttribute('src') !== this.__pzOrig) { this.__pzBad = this.getAttribute('data-pz-thumb'); this.removeAttribute('data-pz-thumb'); this.src = this.__pzOrig; } };
        img.src = pic.src;
        var box = img.parentElement;
        if (box) {
          box.classList.add('pz-ct-box');
          var badge = box.querySelector('.pz-ct-badge');
          if (!badge) { badge = document.createElement('span'); badge.className = 'pz-ct-badge'; box.appendChild(badge); }
          if (badge.textContent !== pic.label) badge.textContent = pic.label;
          if (!box.__pzTap) {
            box.__pzTap = true;
            box.addEventListener('click', function (e) {
              var ln = this.closest('[data-testid="corner-cart-line"]');
              if (!ln || !ln.__pzPic) return;
              e.preventDefault(); e.stopPropagation();
              openLightbox(ln.__pzPic);
            }, true);
          }
        }
      }
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 150);
  }
  /* the drawer opening is a class / style change on Corner's wrapper, not a new node */
  var watched = null;
  function watchDrawer() {
    if (!window.MutationObserver) return;
    var w = document.getElementById('corner-cowi-open-wrapper');
    if (!w || w === watched) return;
    watched = w;
    var mo = new MutationObserver(function () { cart.at = 0; burst(); });
    mo.observe(w, { attributes: true, attributeFilter: ['class', 'style'] });
    var card = document.getElementById('corner-cowi-open-primary-card');
    if (card) mo.observe(card, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  /* a few looks after something happened (the drawer fades in over ~300ms, Corner re-reads the cart first);
     each look is one querySelectorAll while the drawer is closed */
  var burstT = [];
  function burst() {
    burstT.forEach(clearTimeout);
    burstT = [350, 1200, 2600].map(function (ms) { return setTimeout(apply, ms); });
  }
  function start() {
    apply();
    if (window.MutationObserver) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
    /* 18-09 evening: no timer. It re-read /cart.js every 4s on every page with something in the cart (the closed
       drawer's lines are in the DOM), so a phone's radio never slept. The pictures can only change when the drawer
       opens, when Corner re-renders a line, after a tap, or on a bfcache return - those are the triggers now. */
    document.addEventListener('click', function () { cart.at = 0; burst(); }, true);
    document.addEventListener('transitionend', function (e) {
      if (e.target && e.target.id && e.target.id.indexOf('corner-cowi') === 0) soon();
    }, true);
    window.addEventListener('pageshow', function () { cart.at = 0; soon(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
